// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-and-conditions-board {
    height: 75%;
    width: 80%;
    top: 205px;
}

@media (max-height: 500px) {
    .terms-and-conditions-board {
        height: 60%;
        top: 120px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/termsAndConditions/TermsAndConditions.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ","sourcesContent":[".terms-and-conditions-board {\n    height: 75%;\n    width: 80%;\n    top: 205px;\n}\n\n@media (max-height: 500px) {\n    .terms-and-conditions-board {\n        height: 60%;\n        top: 120px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
